module.exports = __webpack_public_path__ + "img/graph-dummy.f12275bf.svg";